import { BaseIntegration, BaseIntegrationData, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';

export class IntegrationLidlModel extends BaseIntegration<BaseIntegrationData, BaseIntegrationState> {
  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/custom/lidl/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Jannik Fischer';
  }
}
